'use strict';

module.exports = /*@ngInject*/
function(
    $http,
    $log,
    $q,
    AjaxLocalStorageService
) {
    return {
        /**
         * Submits an ajax request.
         *
         * @param  {Object}     req
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        ajax: function(req) {
            var deferred = $q.defer();

            this.submitReq(req, deferred);

            return deferred.promise;
        },

        /**
         * Builds an angular $http request object
         * @param  {String}     method
         * @param  {String}     url
         * @param  {Object}     data
         * @param  {Object}     queryParams
         * @return {Object}     An angular $http request object.
         */
        buildReq: function(method, url, data, queryParams) {
            return {
                method: method,
                url: url,
                data: angular.toJson(data) || '',
                params: queryParams || '',
                headers: {
                    // disable IE caching
                    // this will cause OPTIONS pre-flighted requests
                    'Cache-Control': 'no-cache',
                    'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
                    'Pragma': 'no-cache'
                }
            };
        },

        /**
         * Submits and caches an ajax request using
         * the AjaxLocalStorageService. If a previously
         * valid cache is found, no ajax request will
         * be made.
         *
         * @param  {String}     method
         * @param  {String}     url
         * @param  {Object}     data
         * @param  {Object}     queryParams
         * @param  {Object}     options
         * @return {Object}     Promise to be resolved with the ajax or cached response.
         */
        cache: function(method, url, data, queryParams, options) {
            var deferred = $q.defer();
            var req = this.buildReq(method, url, data, queryParams);

            options = options || {};

            if (!AjaxLocalStorageService.isAjaxCached(req, deferred, options)) {
                this.submitReq(req, deferred);
            }

            return deferred.promise;
        },

        /**
         * Convenience method for cached Get requests.
         * @param  {String}     url
         * @param  {Object}     queryParams
         * @param  {Object}     options
         * @return {Object}     Promise to be resolved with the ajax or cached response.
         */
        cachedGet: function(url, queryParams, options) {
            return this.cache('GET', url, '', queryParams, options);
        },

        /**
         * Convenience method for Delete requests.
         * @param  {String}     url
         * @param  {Object}     data
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        'delete': function(url, data) {
            var req = this.buildReq('delete', url, data, ''); // This lower case delete is needed for ie11 unfortunately.
            return this.ajax(req);
        },

        /**
         * Convenience method for Get requests.
         * @param  {String}     url
         * @param  {Object}     data
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        get: function(url, queryParams) {
            var req = this.buildReq('GET', url, '', queryParams);
            return this.ajax(req);
        },

        /**
         * Convenience method for Patch requests.
         * @param  {String}     url
         * @param  {Object}     data
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        patch: function(url, data, queryParams) {
            var req = this.buildReq('PATCH', url, data, queryParams);
            return this.ajax(req);
        },

        /**
         * Convenience method for Post requests.
         * @param  {String}     url
         * @param  {Object}     data
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        post: function(url, data, queryParams) {
            var req = this.buildReq('POST', url, data, queryParams);
            return this.ajax(req);
        },

        /**
         * Convenience method for Put requests.
         * @param  {String}     url
         * @param  {Object}     data
         * @return {Object}     Promise to be resolved with the ajax response.
         */
        put: function(url, data, queryParams) {
            var req = this.buildReq('PUT', url, data, queryParams);
            return this.ajax(req);
        },

        /**
         * Submit a request to Angular's $http service.
         * Will resolve the given deferred with the ajax
         * response.
         * @param  {Object}     req
         * @param  {Object}     deferred
         * @return {Object}     $http promise
         */
        submitReq: function(req, deferred) {
            $log.debug('~~~ ' + req.method + ' AJAX Request for ' + req.url, req);

            return $http(req)
                .success(function onRes(res, status, headers, config) {
                    $log.debug('~~~ ' + req.method + ' AJAX Response for ' + req.url, res, status, headers, config);
                    deferred.resolve(res);
                })
                .error(function onErr(err, status, headers, config) {
                    $log.error('~~~ ' + req.method + ' AJAX Error for ' + req.url, err, status, headers, config);

                    // add res info to err
                    err.status = err.status || status;
                    err.headers = err.headers || headers;
                    err.config = err.config || config;

                    deferred.reject(err);
                });
        }
    };
};
